// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Z7ozt","description":"PatientConsentPreview_description__3kSZA"};